<template>
    <v-container fluid class="pb-6">
      <gg-card class="mb-6">
        <gg-card-header>
          Domain
        </gg-card-header>
        <gg-card-text>
          <v-row>
            <v-col cols="12" md="6" lg="4">
              <domain-select />
            </v-col>
          </v-row>
        </gg-card-text>
      </gg-card>
      <v-stepper v-model="subStep" class="mb-6 rounded-l">
        <v-stepper-header>
          <template v-for="stepItem in subSteps">
            <v-stepper-step
              :key="`st-${stepItem.value}`"
              :step="stepItem.value"
              :complete="subStep > stepItem.value"
            >
            </v-stepper-step>
            <v-divider v-if="stepItem.value < subSteps.length" :key="`std-${stepItem.value}`"></v-divider>
          </template>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content
            v-for="stepItem in subSteps"
            :key="`stc-${stepItem.value}`"
            :step="stepItem.value"
            class="pa-2"
          >
            <component :is="stepItem.component" :ref="stepItem.refName"></component>
          </v-stepper-content>
          <div class="px-6 pb-5">
            <gg-btn class="mr-2" secondary v-show="subStep > 1" @click="subStep--">Back</gg-btn>
            <gg-btn v-show="subStep < subSteps.length" @click="nextSubStep">Next Step</gg-btn>
            <gg-btn v-show="subStep === subSteps.length" @click="submit">Create My website</gg-btn>
          </div>
        </v-stepper-items>
      </v-stepper>
      <!-- v2 END -->
      <v-row>
        <v-col cols="12" class="text-center">
          <gg-btn secondary @click="setStep(1)" tile>
            Back to Wizard Selection
          </gg-btn>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Theme from './StarterSite/Theme'
import ColorSelection from '@/components/Wizard/StepTwo/StarterSite/ColorSelection'
import WebsiteInformation from './StarterSite/WebsiteInformation'
import SocialMedia from './StarterSite/SocialMedia'
import MediaFiles from './StarterSite/MediaFiles'
import OtherInfo from './StarterSite/OtherInfo'
import DomainSelect from '../DomainSelect'
// v2 components:
import WebsiteType from './StarterSite/WebsiteType'
import WebsiteName from './StarterSite/WebsiteName'
import WebsiteAbout from './StarterSite/WebsiteAbout'
import WebsiteProducts from './StarterSite/WebsiteProducts'
import ContactInfo from './StarterSite/ContactInfo'
import WebsiteLogo from './StarterSite/WebsiteLogo'
import WebsiteHours from './StarterSite/WebsiteHours'
import Review from './StarterSite/Review'

export default {
  name: 'StarterSite',
  components: {
    Theme,
    ColorSelection,
    WebsiteInformation,
    SocialMedia,
    MediaFiles,
    OtherInfo,
    DomainSelect,
    // v2 components:
    WebsiteType,
    WebsiteName,
    WebsiteAbout,
    WebsiteProducts,
    ContactInfo,
    WebsiteLogo,
    WebsiteHours,
    Review
  },
  props: {
    loadingApps: {
      type: Boolean,
      required: true,
    },
    appsError: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      subStep: 1,
      subSteps: [
        { value: 1, title: 'Website Type', component: WebsiteType, refName: 'wType' },
        { value: 2, title: 'Website Name', component: WebsiteName, refName: 'wName' },
        { value: 3, title: 'About', component: WebsiteAbout, refName: 'wAbout' },
        { value: 4, title: 'Products', component: WebsiteProducts, refName: 'wProducts' },
        { value: 5, title: 'Contact Info', component: ContactInfo, refName: 'wContact' },
        { value: 6, title: 'Business Hours', component: WebsiteHours, refName: 'wHours' },
        { value: 7, title: 'Website Logo', component: WebsiteLogo, refName: 'wLogo' },
        { value: 8, title: 'Website Theme', component: Theme, refName: 'wTheme' },
        { value: 9, title: 'Review', component: Review, refName: 'wReview' },
      ]
    }
  },
  computed: {},
  methods: {
    ...mapMutations({
      setStep: 'wizard/SET_STEP',
    }),
    submit () {
      this.$emit('submit') // wizard_step3
    },
    async nextSubStep () {
      const refName = this.subSteps[this.subStep - 1].refName
      const valid = await this.$refs[refName][0].validate()
      if (valid) {
        this.subStep += 1
      }
    }
  },
}
</script>
